// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAggregatedEmployeeLinkedAccountsDto
 */
export interface IAggregatedEmployeeLinkedAccountsDto {
    /**
     * 
     * @type {number}
     * @memberof IAggregatedEmployeeLinkedAccountsDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAggregatedEmployeeLinkedAccountsDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IAggregatedEmployeeLinkedAccountsDto
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAggregatedEmployeeLinkedAccountsDto
     */
    large_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IAggregatedEmployeeLinkedAccountsDto
     */
    enrollment_title?: string;
    /**
     * 
     * @type {number}
     * @memberof IAggregatedEmployeeLinkedAccountsDto
     */
    employee_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IAggregatedEmployeeLinkedAccountsDto
     */
    is_created_by_orphan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IAggregatedEmployeeLinkedAccountsDto
     */
    complete_registration_available?: boolean;
}

/**
 * Check if a given object implements the IAggregatedEmployeeLinkedAccountsDto interface.
 */
export function instanceOfIAggregatedEmployeeLinkedAccountsDto(value: object): value is IAggregatedEmployeeLinkedAccountsDto {
    return true;
}

export function IAggregatedEmployeeLinkedAccountsDtoFromJSON(json: any): IAggregatedEmployeeLinkedAccountsDto {
    return IAggregatedEmployeeLinkedAccountsDtoFromJSONTyped(json, false);
}

export function IAggregatedEmployeeLinkedAccountsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAggregatedEmployeeLinkedAccountsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'large_logo_url': json['large_logo_url'] == null ? undefined : json['large_logo_url'],
        'enrollment_title': json['enrollment_title'] == null ? undefined : json['enrollment_title'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'is_created_by_orphan': json['is_created_by_orphan'] == null ? undefined : json['is_created_by_orphan'],
        'complete_registration_available': json['complete_registration_available'] == null ? undefined : json['complete_registration_available'],
    };
}

export function IAggregatedEmployeeLinkedAccountsDtoToJSON(json: any): IAggregatedEmployeeLinkedAccountsDto {
    return IAggregatedEmployeeLinkedAccountsDtoToJSONTyped(json, false);
}

export function IAggregatedEmployeeLinkedAccountsDtoToJSONTyped(value?: IAggregatedEmployeeLinkedAccountsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'organization_name': value['organization_name'],
        'large_logo_url': value['large_logo_url'],
        'enrollment_title': value['enrollment_title'],
        'employee_id': value['employee_id'],
        'is_created_by_orphan': value['is_created_by_orphan'],
        'complete_registration_available': value['complete_registration_available'],
    };
}

